import React from "react";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/vegan_pandan_xoi_1200x900.png";
import { Helmet } from "react-helmet-async";
import useMetaTracking from "../hooks/useMetaTracking";

function PandanXoi() {
  useMetaTracking("ViewContent", {
    content_name: "Sweet Xoi - Pandan",
    content_category: "Vegan Menu",
    content_ids: ["sweet_xoi_pandan"],
    content_type: "vegan_xoi",
    value: 5.0,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Pandan Sticky Rice (Xôi Lá Dứa) | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="This is a true classic. Xôi Lá Dứa gets its beautiful green color and amazing aroma from real pandan leaves. Fragrant, gently sweet, and nutty—the 'vanilla of Southeast Asia.'"
        />
        <meta property="og:title" content="Pandan Sticky Rice (Xôi Lá Dứa) | Đông Hưng Viên Bakery" />
        <meta
          property="og:description"
          content="A classic: naturally green, fragrant, gently sweet, and nutty from real pandan leaves."
        />
        <meta property="og:image" content={CardImg} />
      </Helmet>

      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="Pandan Sticky Rice"
          titleSubHead="Xôi Lá Dứa · $5.00 each"
          detailBody="This is a true classic. Xôi Lá Dứa gets its beautiful green color and amazing aroma from real pandan leaves. It has a fragrant, sweet, and nutty flavor that’s incredibly comforting and delicious."
          detailBodyBr={
            <>
              Contains: coconut
              <br />
              <br />
              <em>Vegan, Gluten-Free</em>
            </>
          }
          ProductCardBtn="View Full Vegan Menu"
          btnLink="/vegan-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default PandanXoi;